module.exports = __webpack_public_path__ + "img/Rosemount Synchros Temperature Monitor.d7e053e3.png";